export const SORT_BY_DRAWER_ID = 'SORT_BY_DRAWER';
export const FILTERS_DRAWER_ID = 'FILTERS_DRAWER';

export const FAVORITES = 'fav';

export const BEAUTY_CATEGORY_NAME = 'beauty';
